import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {WaitingDialogComponent} from "../../shared/waiting-dialog/waiting-dialog.component";
import {AuthService} from "../auth.service";
import {NavigationEnd, Router} from "@angular/router";
import {LoginService} from "./login.service";
import {Http,Response,Headers,RequestOptions} from "@angular/http";
import {MDBModalRef, MDBModalService} from "angular-bootstrap-md";
import {LoginAttributes , NewLoginAttributes} from "./login";
import {ForgotPasswordComponent} from '../forgot-password/forgot-password.component';
import { EncryptfileService } from 'src/app/services/encryptfile.service';
import { filter } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerBranch } from 'src/assets/serverBranch';
import { Config } from 'src/app/services/env.config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  validatingForm: FormGroup;
  configUrl = Config.BaseEndpoint;
  private isLogoutInProgress = false;
  handleRouteChanges : any

  private isConfirmationDialogDisplayed = false;
  constructor(private http: HttpClient,private router: Router,private _http: Http,private encryptService: EncryptfileService, private authService: AuthService, private loginService: LoginService, private modalService: MDBModalService) { }
  // var CryptoJS = require("crypto-js");
  // var base64 = require('base-64');
  // var utf8 = require('utf8');
  ngOnInit() {

    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects === '/login') {
            this.logout();
        }
    });

    this.authService.logoutData();


    this.validatingForm = new FormGroup({
      loginFormModalEmail: new FormControl('', Validators.required),
      loginFormModalPassword: new FormControl('', Validators.required)
    });
  }

  get loginFormModalEmail() {
    return this.validatingForm.get('loginFormModalEmail');
  }

  get loginFormModalPassword() {
    return this.validatingForm.get('loginFormModalPassword');
  }

  waitingModalRef: MDBModalRef;
  loginCredentials: LoginAttributes = new LoginAttributes();
  newloginCredentials: NewLoginAttributes = new NewLoginAttributes();
  forgotPswdmodalRef: MDBModalRef;
  openForgotPasswordBox() {
    this.forgotPswdmodalRef = this.modalService.show(ForgotPasswordComponent, {
      data: {
        message: ''
      }
    });
    this.forgotPswdmodalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
        setTimeout(x => {
          this.forgotPswdmodalRef.hide();
        }, 300)
      }
    });
  }

  checkAuthLogin(){
    this.authService.checkAuth()
  }


  login() {
    if (this.loginFormModalEmail.value == '' || this.loginFormModalPassword.value == '') {
      alert('Please enter username and password')
    }
    else {
      this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
        data: {
          message: 'Logging In'
        }
      })

// var base64str = new base64str();
      this.newloginCredentials.UserName = this.loginFormModalEmail.value;
      this.newloginCredentials.Password =this.loginFormModalPassword.value;
      this.authService
        .loginNew(this.newloginCredentials)
        .then((response: any) => {
            setTimeout(x => {
              this.waitingModalRef.hide();
           }, 500)
         // console.log(response.errorno)
          if(response.TokenId) {
            sessionStorage.setItem('Status', 'true');
            sessionStorage.setItem('RSSO', JSON.stringify(response.ISRSSO));
            sessionStorage.setItem('DealUserName', JSON.stringify(response.UserName));
           if(response.CountryImage !=undefined){
            sessionStorage.setItem('countryImagePath',JSON.stringify(response.CountryImage))
           }
            //response['DealUserName'] = response.UserName;
            //this.authService.isLoggedIn = true;
            sessionStorage.setItem('user', JSON.stringify(response));
           if(response.DesigName) {
             sessionStorage.setItem('DesigName', JSON.stringify(response.DesigName));
           }
             setTimeout(x => {
                        this.checkAuthLogin()

            }, 500)
            //this.router.navigate(['/main/home']);
          }
          else if(response.errorno ==1){
           setTimeout(x => {
              this.waitingModalRef.hide();
            }, 500)
            console.log(response);
            alert("User not exists");
          }
          else if(response.errorno ==2 ){
            setTimeout(x => {
               this.waitingModalRef.hide();
             }, 500)
             console.log(response);
             alert("User deactivates");
           }
           else if(response.errorno ==4 ){
            setTimeout(x => {
               this.waitingModalRef.hide();
             }, 500)
             console.log(response);
             alert("Password wrong");
           }
           else if(response.errorno ==-1){
            setTimeout(x => {
               this.waitingModalRef.hide();
             }, 500)
             console.log(response);
             alert("Inactive User");
           }
           else if(response.errorno ==7 ){
            setTimeout(x => {
               this.waitingModalRef.hide();
             }, 500)
             console.log(response);
             alert("Reset password");
           }        
            
        }, (error) => {
          console.log(error)
          setTimeout(x => {
            this.waitingModalRef.hide();
          }, 500)
          console.log(error);
          if (error.status == 400) {
            alert("Invalid Username or Password")
          }
        });
    }
  }





  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'

    })
  };
  logout() {
        const logoutDomain=ServerBranch.getLogoutDomain();

    let sessionData = JSON.parse(sessionStorage.getItem('user')) ;
   
    let user = { UserName : sessionData.UserName }; 
    this.http 
    //IBDIENTS
    //.post(Config.BaseEndpoint  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
    //UAT
     .post(logoutDomain  + '/CheckLogoutUser', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response) => {
        alert('Session End')
        // Handle the API response
        this.isLogoutInProgress = false;
        this.router.navigate(['/login']);
        sessionStorage.clear();
        localStorage.clear();
       // this.cookieService.deleteAll()
      // this.clearAllCookies()
      })
      .catch((error) => {
        // Handle any errors
        console.error(error);
        //this.messageService.errorMessage(error.error_msg, 'error');
      });
  }
}
